import classnames from 'classnames';
import styles from './ProgressIndicator.module.css';

export interface IProgressIndicatorProps {
    color?: 'danger' | 'emergency';
    percentage: number;
    statusText: string;
}

export function ProgressIndicator(props: IProgressIndicatorProps) {
    const className = props.color ? `has-background-${props.color}` : 'has-background-success';
    const textColor = props.percentage > 0 ? 'HorizontalFormGroupRead-module__has-text-success' : 'colors__color-muted';

    return (
        <div className="row align-items-center">
            <div className="col-12 p-0">
                <div className={styles.slider}>
                    <div
                        className={classnames(styles.bar, className)}
                        style={{ width: props.percentage + '%' }}
                    ></div>
                </div>
            </div>
            <div className="col-6">
                <div className={`${textColor} type__weight-bold`}>{props.percentage}%</div>
            </div>
            <div className="col-6 p-0">
                <div className="colors__color-muted type__weight-bold">{props.statusText}</div>
            </div>
        </div>
    );
}
